/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { Backdrop, Button, Typography, Box } from '@material-ui/core';
import cn from 'classnames';
import useStyles from './useStyles';

const ConfirmationPopup = ({
  heading,
  message,
  buttons,
}) => {
  const classes = useStyles();

  const getClassName = (btnTxt) => {
    const primaryBtnTxt = ['ok', 'yes', 'confirm'];
    const primary = primaryBtnTxt.includes(String(btnTxt).toLowerCase());
    return primary ? classes.primaryButton : classes.secondaryButton;
  };

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <Box className={classes.container}>
        <Typography variant='h6' className={classes.title} align='center'>
          {heading}
        </Typography>
        <Typography variant='body1' className={classes.bodyText} align='center'>
          {message}
        </Typography>
        {Array.isArray(buttons) && (
          <Box className={classes.buttonsWrapper}>
            {buttons.map(button =>
              <Button key={`key-${button.text}`} size='small' className={cn(classes.button, getClassName(button.text))} onClick={button.onClick}>
                {button.text}
              </Button>
            )}
          </Box>
        )}
      </Box>
    </Backdrop>
  );
};

export default ConfirmationPopup;
